<template>
  <div class="login">
    <el-container>

        <el-image
        class="loginPic"
        :src="require('@/assets/2.png')"
        ></el-image>


          <el-row class="LoginBlock">

            <h1 style="color: black;">资产管理系统登录界面</h1>


            <el-form  :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item class="LoginInput" label="输入账号" prop="pass">
                <el-input v-model.trim ="ruleForm.pass" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item class="LoginInput" label="输入密码" prop="checkPass">
                <el-input type="password" v-model.trim ="ruleForm.checkPass" autocomplete="off"></el-input>
              </el-form-item>

              <el-form-item class="LoginButton">
                <el-row>
                  <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                  <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-row>
              </el-form-item>
            </el-form>
          </el-row>
      <!-- </el-main> -->
    </el-container>
  </div>
</template>

<script>
import Header from "./Tool/Header.vue"
import axios from "axios"
import Cookies from "js-cookie";
 export default {
    name: 'Login',
    components: {Header},
    data () {
			// 页面前端侦测是否有数据为空的情况
      var validatePass = (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入账号'));
              } else {
                if (this.ruleForm.checkPass !== '') {
                  this.$refs.ruleForm.validateField('checkPass');
                }
                callback();
              }
            };
            var validatePass2 = (rule, value, callback) => {
              if (value === '') {
                callback(new Error('请输入密码'));
              } else {

                callback();
              }
            };
      return {
				// 登录的判断规则
        rules: {
                  pass: [
                    { validator: validatePass, trigger: 'blur' }
                  ],
                  checkPass: [
                    { validator: validatePass2, trigger: 'blur' }
                  ],
                },
			
           ruleForm: {
                    pass: '',
                    checkPass: '',
                  },
		  // 账号数据
          input:'',
		 // 登陆时状态码的数据
          Code:'',
		  // 密码数据
          input2:'',
		  // 登录成功之后小杜返给我们的数据
          From:{
            username:'',
            id:'',
            deptId:'',
            email:'',
            headImg:'',
            phone:'',
            remark:'',
            password:'',
            status:'',
            sex:'',
            role_id:'',
            unitId:''

          }
      }
    },methods:{
		// 点击之后判断数据是否为空
		submitForm(formName) {
              this.$refs[formName].validate((valid) => {
                this.toLogin()
              });
            },
		// 重置功能,将所有数据抹除
        resetForm(formName) {
              this.$refs[formName].resetFields();
            },

	  // 登录成功的提示
      open2(val) {
              this.$notify({
                title: '操作成功',
                message: val,
                type: 'success',
                duration: 3000
              });
            },
	  // 登录失败的提示
      open3(val) {
             this.$notify({
               title: '操作失败',
               message: val,
               type: 'error',
               duration: 3000
             });
           },

	  // 登录的主要方法,获取到的数据全部存在Cookies中,
	  // /sys/login返回了一个登录用户所需要最重要的数据Authorization
	  // token就是存在Authorization里面
      toLogin(){
        this.axios({
            method: 'POST',
            url: '/sys/login',
            params:{
              username:this.ruleForm.pass,
              password:this.ruleForm.checkPass
            }
          }).then((resp)=>{
            if (resp.data.code == 200) {
              this.open2()
              this.From = resp.data;
			  sessionStorage.setItem("Authorization",resp.headers.authorization)
			  sessionStorage.setItem("UserName",this.From.data.username)
			  sessionStorage.setItem("Sex",this.From.data.sex)
			  sessionStorage.setItem("ID",this.From.data.userId)
			  sessionStorage.setItem("DeptId",this.From.data.deptId)
			  sessionStorage.setItem("Email",this.From.data.email)
			  sessionStorage.setItem("HeadImg",this.From.data.headImg)
			  sessionStorage.setItem("Phone",this.From.data.phone)
			  sessionStorage.setItem("Code",resp.data.code)
			  
              Cookies.set("Code",resp.data.code);
              Cookies.set("Authorization",resp.headers.authorization)
              Cookies.set("UserName",this.From.data.username)
              Cookies.set("Sex",this.From.data.sex)
              Cookies.set("ID",this.From.data.userId)
              Cookies.set("DeptId",this.From.data.deptId)
              Cookies.set("Email",this.From.data.email)
              Cookies.set("HeadImg",this.From.data.headImg)
              Cookies.set("Phone",this.From.data.phone)
              Cookies.set("Remark",this.From.data.remake)
              Cookies.set("Role_id",this.From.data.roleIds)
              Cookies.set("UnitId",this.From.data.unitId)
              Cookies.set("Roles",this.From.data.roles)
              Cookies.set("Status",resp.status)
              let sessionStorageData = JSON.stringify([{title: "主页", name: "1", content: "Tab 1 content", components: "/index"}])
              sessionStorage.setItem('Data', sessionStorageData)
              this.$router.push("/index")
			    

            }

            if(resp.data.code!=200){
              this.open3(resp.data.message)
              return;
            }


          })


      }
    }
  }
</script>

<style>
  .login{
    height: 1080px;
    background-color: white;
  }
  .loginPic{
    margin-top: 8%;
    margin-left: 25%;
    width: 500px;
    height: 500px;
  }
	.hy_image{
		width: 200px;
		height: 200px;
		margin-top: 50%;
		margin-left: 45%;
	}

  .LoginBlock{

      margin-top: 17%;
      background-color: white;
      width: 400px;
      height: 300px;
      border-radius: 5px;
      border-bottom: 1px;
      display:inline-block;

  }
  .button{
    margin-top: 1%;
  }
  .LoginInput{
    width: 350px;
  }
  .LoginButton{
    width: 300px;
    margin-right: 60%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue